import React from 'react';
import { Check, Copy, Linkedin, Mail, MessageCircle, Twitter } from 'lucide-react';
import { buildShareTargets } from '../../utils/referral';
interface ReferralShareButtonsProps {
  url: string;
  copied: boolean;
  onCopy: () => void;
  disabled?: boolean;
}
const ICONS = {
  whatsapp: MessageCircle,
  x: Twitter,
  linkedin: Linkedin,
  email: Mail
} as const;
export function ReferralShareButtons({
  url,
  copied,
  onCopy,
  disabled = false
}: ReferralShareButtonsProps) {
  const targets = buildShareTargets(url);
  const base = 'inline-flex flex-1 min-w-[84px] items-center justify-center gap-2 rounded-xl border border-gray-800 bg-[#0F0F0F] px-3 py-3 text-xs font-bold uppercase tracking-wider text-gray-300 transition-colors duration-200 ease-out hover:border-gray-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#050505]';
  return <div className="flex flex-wrap gap-2" data-id="element-1764" data-mp="15rnuqrghc7ug">
      {targets.map(target => {
      const Icon = ICONS[target.id];
      return <a key={target.id} href={disabled ? undefined : target.href} target={target.id === 'email' ? undefined : '_blank'} rel="noopener noreferrer" aria-disabled={disabled || undefined} className={`${base} ${disabled ? 'pointer-events-none opacity-50' : ''}`} data-id="element-1765" data-mp="1dd0q38e7l8wd">
            <Icon size={15} aria-hidden="true" data-id="element-1766" data-mp="1wb36wzwlrzj3" />
            <span data-id="element-1767" data-mp="1w9s535mpx1um">{target.label}</span>
          </a>;
    })}
      <button type="button" onClick={onCopy} disabled={disabled} className={`${base} disabled:pointer-events-none disabled:opacity-50 ${copied ? 'border-green-500/40 text-green-400' : ''}`} data-id="element-1768" data-mp="1s8ygsb5d5l17">
        {copied ? <Check size={15} aria-hidden="true" data-id="element-1769" data-mp="214nxw7zs3t8s" /> : <Copy size={15} aria-hidden="true" data-id="element-1770" data-mp="2g0djw64ys6di" />}
        <span data-id="element-1771" data-mp="2b0ray8w65cai">{copied ? 'Copied' : 'Copy link'}</span>
      </button>
    </div>;
}